import { getToken } from 'src/auth';
import { api } from 'src/api/config';

const API_BASE_URL = api.hostname;

export const FETCH_TRANSACTION_SUMMARY_REQUEST = 'FETCH_TRANSACTION_SUMMARY_REQUEST';
export const FETCH_TRANSACTION_SUMMARY_SUCCESS = 'FETCH_TRANSACTION_SUMMARY_SUCCESS';
export const FETCH_TRANSACTION_SUMMARY_ERROR = 'FETCH_TRANSACTION_SUMMARY_ERROR';

export const FETCH_TRANSACTION_LIST_REQUEST = 'FETCH_TRANSACTION_LIST_REQUEST';
export const FETCH_TRANSACTION_LIST_SUCCESS = 'FETCH_TRANSACTION_LIST_SUCCESS';
export const FETCH_TRANSACTION_LIST_ERROR = 'FETCH_TRANSACTION_LIST_ERROR';

export const fetchTransactionSummary =
  ({ fi, account, dateFrom, dateTo, status, discrepancy_type }) =>
  async (dispatch, getState) => {
    dispatch({ type: FETCH_TRANSACTION_SUMMARY_REQUEST });
    try {
      const state = getState();
      const token = getToken(state);

      const params = new URLSearchParams();
      if (dateFrom) params.append('date_from', dateFrom);
      if (dateTo) params.append('date_to', dateTo);
      if (status) params.append('status', status);
      if (discrepancy_type) params.append('discrepancy_type', discrepancy_type);

      const queryString = params.toString() ? `?${params.toString()}` : '';
      const url = `${API_BASE_URL}/api/v1/transactions/summary/${fi}/${account}/${queryString}`;

      const response = await fetch(url, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token.accessToken}`,
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      dispatch({
        type: FETCH_TRANSACTION_SUMMARY_SUCCESS,
        payload: data,
      });
    } catch (error) {
      dispatch({
        type: FETCH_TRANSACTION_SUMMARY_ERROR,
        payload: error.message,
      });
    }
  };

export const fetchTransactionList =
  ({ fi, account, page = 1, pageSize = 50, dateFrom, dateTo, status, search, min_amount, max_amount, discrepancy_type, late }) =>
  async (dispatch, getState) => {
    dispatch({ type: FETCH_TRANSACTION_LIST_REQUEST });
    try {
      const state = getState();
      const token = getToken(state);

      const params = new URLSearchParams();
      params.append('page', page);
      params.append('page_size', pageSize);
      if (dateFrom) params.append('date_from', dateFrom);
      if (dateTo) params.append('date_to', dateTo);
      if (status) params.append('status', status);
      if (search) params.append('search', search);
      if (min_amount) params.append('min_amount', min_amount);
      if (max_amount) params.append('max_amount', max_amount);
      if (discrepancy_type) params.append('discrepancy_type', discrepancy_type);
      if (late) params.append('late', late);

      const queryString = params.toString() ? `?${params.toString()}` : '';
      const url = `${API_BASE_URL}/api/v1/transactions/list/${fi}/${account}/${queryString}`;

      const response = await fetch(url, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token.accessToken}`,
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      dispatch({
        type: FETCH_TRANSACTION_LIST_SUCCESS,
        payload: data,
      });
    } catch (error) {
      dispatch({
        type: FETCH_TRANSACTION_LIST_ERROR,
        payload: error.message,
      });
    }
  };

// FI-Wide endpoints (for Super Admin and FI Admin)
export const fetchFITransactionSummary =
  ({ fi, dateFrom, dateTo, status, discrepancy_type }) =>
  async (dispatch, getState) => {
    dispatch({ type: FETCH_TRANSACTION_SUMMARY_REQUEST });
    try {
      const state = getState();
      const token = getToken(state);

      const params = new URLSearchParams();
      if (dateFrom) params.append('date_from', dateFrom);
      if (dateTo) params.append('date_to', dateTo);
      if (status) params.append('status', status);
      if (discrepancy_type) params.append('discrepancy_type', discrepancy_type);

      const queryString = params.toString() ? `?${params.toString()}` : '';
      const url = `${API_BASE_URL}/api/v1/transactions/fi-summary/${fi}/${queryString}`;

      const response = await fetch(url, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token.accessToken}`,
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      dispatch({
        type: FETCH_TRANSACTION_SUMMARY_SUCCESS,
        payload: data,
      });
    } catch (error) {
      dispatch({
        type: FETCH_TRANSACTION_SUMMARY_ERROR,
        payload: error.message,
      });
    }
  };

export const fetchFITransactionList =
  ({ fi, page = 1, pageSize = 50, dateFrom, dateTo, status, search, min_amount, max_amount, discrepancy_type, late }) =>
  async (dispatch, getState) => {
    dispatch({ type: FETCH_TRANSACTION_LIST_REQUEST });
    try {
      const state = getState();
      const token = getToken(state);

      const params = new URLSearchParams();
      params.append('page', page);
      params.append('page_size', pageSize);
      if (dateFrom) params.append('date_from', dateFrom);
      if (dateTo) params.append('date_to', dateTo);
      if (status) params.append('status', status);
      if (search) params.append('search', search);
      if (min_amount) params.append('min_amount', min_amount);
      if (max_amount) params.append('max_amount', max_amount);
      if (discrepancy_type) params.append('discrepancy_type', discrepancy_type);
      if (late) params.append('late', late);

      const queryString = params.toString() ? `?${params.toString()}` : '';
      const url = `${API_BASE_URL}/api/v1/transactions/fi-list/${fi}/${queryString}`;

      const response = await fetch(url, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token.accessToken}`,
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      dispatch({
        type: FETCH_TRANSACTION_LIST_SUCCESS,
        payload: data,
      });
    } catch (error) {
      dispatch({
        type: FETCH_TRANSACTION_LIST_ERROR,
        payload: error.message,
      });
    }
  };

// Super Admin - All FIs endpoints
export const fetchAllTransactionsSummary =
  ({ dateFrom, dateTo, status, discrepancy_type }) =>
  async (dispatch, getState) => {
    dispatch({ type: FETCH_TRANSACTION_SUMMARY_REQUEST });
    try {
      const state = getState();
      const token = getToken(state);

      const params = new URLSearchParams();
      if (dateFrom) params.append('date_from', dateFrom);
      if (dateTo) params.append('date_to', dateTo);
      if (status) params.append('status', status);
      if (discrepancy_type) params.append('discrepancy_type', discrepancy_type);

      const queryString = params.toString() ? `?${params.toString()}` : '';
      const url = `${API_BASE_URL}/api/v1/transactions/all-summary/${queryString}`;

      const response = await fetch(url, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token.accessToken}`,
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      dispatch({
        type: FETCH_TRANSACTION_SUMMARY_SUCCESS,
        payload: data,
      });
    } catch (error) {
      dispatch({
        type: FETCH_TRANSACTION_SUMMARY_ERROR,
        payload: error.message,
      });
    }
  };

export const fetchAllTransactionsList =
  ({ page = 1, pageSize = 50, dateFrom, dateTo, status, search, min_amount, max_amount, discrepancy_type, late }) =>
  async (dispatch, getState) => {
    dispatch({ type: FETCH_TRANSACTION_LIST_REQUEST });
    try {
      const state = getState();
      const token = getToken(state);

      const params = new URLSearchParams();
      params.append('page', page);
      params.append('page_size', pageSize);
      if (dateFrom) params.append('date_from', dateFrom);
      if (dateTo) params.append('date_to', dateTo);
      if (status) params.append('status', status);
      if (search) params.append('search', search);
      if (min_amount) params.append('min_amount', min_amount);
      if (max_amount) params.append('max_amount', max_amount);
      if (discrepancy_type) params.append('discrepancy_type', discrepancy_type);
      if (late) params.append('late', late);

      const queryString = params.toString() ? `?${params.toString()}` : '';
      const url = `${API_BASE_URL}/api/v1/transactions/all-list/${queryString}`;

      const response = await fetch(url, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token.accessToken}`,
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      dispatch({
        type: FETCH_TRANSACTION_LIST_SUCCESS,
        payload: data,
      });
    } catch (error) {
      dispatch({
        type: FETCH_TRANSACTION_LIST_ERROR,
        payload: error.message,
      });
    }
  };
